import React from 'react';
import styles from './styles.module.scss';

export function StatusMessage(props: { statusMessage: string | JSX.Element }): JSX.Element {
    return (
        <div className={`flexColumnFullHeightContainer ${styles.statusMessageComponent}`}>
            <span className="text-info">{props.statusMessage}</span>
        </div>
    );
}
